import React, { Fragment } from 'react';
import { ToastContainer } from 'react-toastify';

// -------

const ToastLayout = () => {
  return (
    <Fragment>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        />
    </Fragment>
  );
};

export default ToastLayout;
